import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';

export const useUrlPagination = (key: string, defaultPage = 1, cleanupOnUnmount = true) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const pageParam = searchParams.get(`${key}Page`);
  const page = pageParam ? parseInt(pageParam, 10) : defaultPage;

  const setPage = (newPage: number) => {
    const params = new URLSearchParams(searchParams);
    params.set(`${key}Page`, String(newPage));
    setSearchParams(params, { replace: true });
  };

  useEffect(() => {
    return () => {
      if (cleanupOnUnmount) {
        const params = new URLSearchParams(searchParams);
        params.delete(`${key}Page`);
        setSearchParams(params, { replace: true });
      }
    };
  }, []);

  return {
    page,
    setPage,
  };
};
